import { Download, FileSpreadsheet } from "lucide-react";
import { AIResponseReportingMessage } from "winslow-core";
import "./ReportViewer.css";
import { Button } from "../../../ds2/components";
import { WazToolbar } from "../toolbar/WazToolbar";

type ReportViewerProps = {
  message?: AIResponseReportingMessage;
  explanation: string;
  reportData: any[];
  columns: string[];
  showLabel: (objectKey: string, propertyKey: string) => boolean;
  getLabel: (objectKey: string, propertyKey: string) => string;
  onCancel: () => void;
  onExport: () => void;
};

export const ReportViewer = ({
  message,
  explanation,
  reportData,
  columns,
  showLabel,
  getLabel,
  onCancel,
  onExport,
}: ReportViewerProps) => {
  return (
    <div className="report-viewer">
      <WazToolbar />

      <div className="report-viewer-content"> 
        <div className="viewer-header">
          <div className="viewer-title-section">
            <div className="viewer-report-info">
              <FileSpreadsheet className="viewer-report-icon" size={24} />
              <span className="viewer-report-type-label">REPORT</span>
              <h2 className="viewer-report-title">
                {explanation ? "Employee Report" : "Data Report"}
              </h2>
              {reportData && Array.isArray(reportData) && (
                <span className="viewer-report-count">
                  {reportData.length} record{reportData.length !== 1 ? 's' : ''}
                </span>
              )}
            </div>
          </div>
          
          <div className="viewer-actions">
            <Button
              variant="primary"
              onClick={onExport}
              disabled={!reportData || reportData.length === 0}
              leftIcon={<Download size={16} />}>
              Export
            </Button>
            <Button
              variant="secondary"
              onClick={onCancel}
            >
              Done
            </Button>
            
            {/* <button
              className="sidebar-action-button export-button"
              onClick={onExport}
              disabled={!reportData || reportData.length === 0}>
              <Download size={16} />
              Export CSV
            </button>
            <button className="action-button cancel-button" onClick={onCancel}>
              Done
            </button> */}
          </div>
        </div>

        <div className="viewer-main">
          <div className="main-content">
            {reportData && reportData.length > 0 ? (
              <div className="report-table-container">
                <div 
                  className="report-table"
                  style={{
                    gridTemplateColumns: `repeat(${columns.filter((column) => showLabel("employee-record", column)).length}, 1fr)`,
                  }}>
                  {/* Table headers */}
                  {columns
                    .filter((column) => showLabel("employee-record", column))
                    .map((column, index) => (
                      <div key={index} className="table-header">
                        {getLabel("employee-record", column)}
                      </div>
                    ))}
                  
                  {/* Table rows */}
                  {reportData.map((row, rowIndex) => {
                    // Convert to Map format if needed
                    const rowMap = row instanceof Map ? row : new Map(Object.entries(row));
                    
                    return columns
                      .filter((column) => showLabel("employee-record", column))
                      .map((column, colIndex) => {
                        let cellData = rowMap.get ? rowMap.get(column) : row[column];
                        if (typeof cellData === "object") {
                          cellData = JSON.stringify(cellData);
                        }
                        return (
                          <div 
                            key={`${rowIndex}-${colIndex}`} 
                            className={`table-cell ${rowIndex % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                            {cellData || 'N/A'}
                          </div>
                        );
                      });
                  })}
                </div>
              </div>
            ) : (
              <div className="empty-report">
                <FileSpreadsheet size={48} color="#ccc" />
                <h3>No Data Available</h3>
                <p>There are no records to display in this report.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};